import { UserInfo } from "../types/domain/User";

import useAxiosConfig from "./useAxiosConfig";
import useAxiosHeader from "./useAxiosHeader";

const useInternalAxiosConfig = (
  userData: UserInfo | null | undefined,
  setData: (data: any) => void,
  apiBaseUrl?: string,
  refreshTokenUrl?: string,
  forbiddenCallback?: () => void,
  sessionId?: string,
  clientId?: string,
  refreshTokenBaseUrl?: string
) => {
  useAxiosHeader("X-Session-Id", sessionId);

  return useAxiosConfig(
    userData,
    setData,
    apiBaseUrl,
    refreshTokenUrl,
    true,
    clientId,
    forbiddenCallback,
    refreshTokenBaseUrl
  );
};

export default useInternalAxiosConfig;
